import { isValidPhoneNumber } from "react-phone-number-input";
import { z } from "zod";
import {
  invalidPlatformUrl,
  invalidUrl,
  validatePlatformUrl,
} from "../structure";

export const url = z.union([z.string().url(), z.string().length(0)]).optional();

export const addOrganiserExhibitorSchema = z.object({
  connectEventId: z.union([
    z.string().length(0, "L'ID Connect'Events n'est pas valide"),
    z.string().length(10),
  ]),
  businessName: z.string(),
  businessSector: z.string(),
  businessEmail: z.string().min(1, "Mail requis").email("Email invalide"),
  phoneNumber: z.union([
    z.string().refine((phoneNumber) => isValidPhoneNumber(phoneNumber, "FR"), {
      message: "Téléphone invalide",
    }),
    z.string().length(0),
  ]),
  address: z.string(),
  city: z.string(),
  zipCode: z.string(),
  websiteUrl: url,
  linkedinUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["linkedin.com"]), {
      message: invalidPlatformUrl("LinkedIn"),
    })
    .or(z.literal(""))
    .nullish(),
  facebookUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["facebook.com"]), {
      message: invalidPlatformUrl("Facebook"),
    })
    .or(z.literal(""))
    .nullish(),
  twitterUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["twitter.com", "x.com"]), {
      message: invalidPlatformUrl("X (Twitter)"),
    })
    .or(z.literal(""))
    .nullish(),
  instagramUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["instagram.com"]), {
      message: invalidPlatformUrl("Instagram"),
    })
    .or(z.literal(""))
    .nullish(),
  youtubeUrl: z
    .string()
    .url(invalidUrl)
    .refine(validatePlatformUrl(["youtube.com"]), {
      message: invalidPlatformUrl("YouTube"),
    })
    .or(z.literal(""))
    .nullish(),
});

export const defaultAddOrganiserExhibitorValues = {
  connectEventId: "",
  businessName: "",
  businessSector: "",
  businessEmail: "",
  phoneNumber: "",
  address: "",
  city: "",
  zipCode: "",
  websiteUrl: "",
  linkedinUrl: "",
  facebookUrl: "",
  twitterUrl: "",
  instagramUrl: "",
  youtubeUrl: "",
};

export type AddOrganiserExhibitorForm = z.infer<
  typeof addOrganiserExhibitorSchema
>;
